<template>
    <div class="home">
        <Header ref="header" :type='headType' @childEvent="scrollToAnchor"></Header>
        <BanIn url="image001">
            <template v-slot:text>
                <h2 class="inTit f48 wow fadeInLeft">关于我们</h2>
                <div class="inDes f24 wow fadeInRight">
                    <p>提供仓储、装卸、简单包装、配送、库存管理、信息处理、咨询等“一站式”综合物流服务</p>
                </div>
            </template>
        </BanIn>
        <div class="mainBg">
            <div class="aBg aBg1" id="company">
                <div class="wrap">
                    <div class="hmTit text-center wow fadeInDown">
                        <h2 class="hmTitCn f40 color0">关于我们</h2>
                    </div>
                    <ul class="sortList wow fadeInUp" id="anchor">
                        <li class="active"><a @click="scrollToAnchor('company')">公司概况</a></li>
                        <li><a @click="scrollToAnchor('history')">历史发展</a></li>
                        <li><a @click="scrollToAnchor('mission')">使命与愿景</a></li>
                        <li><a @click="scrollToAnchor('team')">团队成员</a></li>
                    </ul>
                    <div class="hm2Top">
                        <div class="hm2Img wow fadeInLeft">
                            <img :src="hm2Info.image" alt="">
                        </div>
                        <div class="hm2Text">
                            <h3 class="hm2Tit f30 color3">{{hm2Info.title}}</h3>
                            <div class="hm2Con f18 color6 wow fadeInUp">
                                <div class="hm2des" v-html="hm2Info.content">
                                </div>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <ul class="hm2List list-style flex justify-between f18 color6 text-center">
                        <li class="wow fadeInLeft" data-wow-delay="0.1s">
                            <div class="hm2Item f18 color_m">
                                <strong class="f60">{{hm2Info.establishment_time}}</strong>
                                <span>年</span>
                            </div>
                            <p>成立于</p>
                        </li>
                        <li class="wow fadeInLeft" data-wow-delay="0.2s">
                            <div class="hm2Item f18 color_m">
                                <strong class="f60">{{hm2Info.division}}</strong>
                                <span>个</span>
                            </div>
                            <p>事业部</p>
                        </li>
                        <li class="wow fadeInLeft" data-wow-delay="0.3s">
                            <div class="hm2Item f18 color_m">
                                <strong class="f60">{{hm2Info.warehouse_area}}</strong>
                                <span>万平方米</span>
                            </div>
                            <p>仓储面积超过</p>
                        </li>
                        <li class="wow fadeInLeft" data-wow-delay="0.4s">
                            <div class="hm2Item f18 color_m">
                                <strong class="f60">{{hm2Info.staff}}</strong>
                                <span>余人</span>
                            </div>
                            <p>员工</p>
                        </li>
                        <li class="wow fadeInLeft" data-wow-delay="0.4s">
                            <div class="hm2Item f18 color_m">
                                <strong class="f60">{{hm2Info.vehicle}}</strong>
                                <span>辆+</span>
                            </div>
                            <p>流动车辆</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="aBg aBg2" id="history" ref="history">
                <div class="wrap">
                    <div class="hmTit text-center wow fadeInDown">
                        <h2 class="hmTitCn f40 color_f">发展历程</h2>
                        <div class="hmTitDes f20 color_f">
                            <p>公司以“一切为了客户，为了客户一切”为服务宗旨</p>
                        </div>
                    </div>
                    <div class="a2Box wow fadeInUp">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" :class="a2Hover == index ? 'active' : '' " @mouseenter="a2Hover = index" v-for="(item, index) in a2List" :key="index">
                                    <div class="a2Year">{{item.year}}</div>
                                    <span class="a2Dot"></span>
                                    <div class="a2Img">
                                        <img :src="item.image">
                                    </div>
                                    <div class="a2Text">
                                        <p v-for="(a, i) in item.content_data" :key="i">{{ a.value_1 }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="a2Btn white flex align-center justify-center">
                            <span class="hmPrev hm2Prev"><i class="el-icon-arrow-left"></i></span>
                            <span class="hmNext hm2Next"><i class="el-icon-arrow-right"></i></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="aBg aBg3" id="mission">
                <div class="wrap">
                    <div class="hmTit text-center wow fadeInDown">
                        <h2 class="hmTitCn f40 color0">使命与愿景</h2>
                        <div class="hmTitDes f20 color6">
                            <p>提供仓储、装卸、简单包装、配送、库存管理、信息处理、咨询等“一站式”综合物流服务</p>
                        </div>
                    </div>
                    <div class="a3Box text-center wow fadeInUp">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="(item, index) in a3List" :key="index">
                                    <div class="a3Item">
                                        <div class="a3Icon flex-center">
                                            <img :src="item.icon" alt="">
                                        </div>
                                        <h3 class="a3Tit f30 color3">{{ item.title }}</h3>
                                        <div class="a3Text f18 color6" v-html="item.content"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="a3Btn flex align-center justify-center">
                            <span class="hmPrev hm2Prev"><i class="el-icon-arrow-left"></i></span>
                            <span class="hmNext hm2Next"><i class="el-icon-arrow-right"></i></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="aBg aBg4" id="team">
                <div class="wrap">
                    <div class="hmTit text-center wow fadeInDown">
                        <h2 class="hmTitCn f40 color0">员工风采</h2>
                        <div class="hmTitDes f20 color6">
                            <p>力求每一个细节的完美，保证用户获得放心满意的产品</p>
                        </div>
                    </div>
                    <div class="a4Box text-center wow fadeInUp">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="(item, index) in a4List" :key="index">
                                    <div class="a4Img">
                                        <img :src="item.image" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hm-pagination"></div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import BanIn from '@/components/BanIn.vue'
import Footer from '@/components/Footer.vue'
import Swiper from 'swiper'  // ES引入方式
import { WOW } from 'wowjs'
import home from '@/api/home'
export default {
    name: 'About',
    components: {
        Header,
        BanIn,
        Footer
    },
    data() {
        return {
            headType:3,
            hm2Info:'',
            a2List:[],
            a2Hover: 0,
            a3List:[
                {
                    icon: require('@/assets/images/about/about-icon1.png'),
                    title:'企业愿景',
                    content:'领跑绿色城市物流  服务百姓美好生活'
                },
                {
                    icon: require('@/assets/images/about/about-icon2.png'),
                    title:'企业使命',
                    content:'服务客户  成就自我  回报社会'
                },
                {
                    icon: require('@/assets/images/about/about-icon3.png'),
                    title:'质量方针',
                    content:'<p>诚实守法  安全快捷</p><p>准确细致  持续改进</p>'
                },
            ],
            a4List:[]
        }
    },
    watch: {
        '$route' () {
            console.log(this.$route.query.id)
            setTimeout(() => {
                this.scrollToAnchor(this.$route.query.id)
            }, 100);
        }
    },
    computed: {
        
    },

    created() {
    },
    mounted () {
        this.$nextTick(()=>{
            new WOW({ boxClass:"wow",animateClass:"animated",offset:5,mobile:true,live:false,resetAnimation:true }).init()
            new Swiper('.a2Box .swiper-container', {
                speed: 500,
                spaceBetween: '6%',
                slidesPerView: 1,
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                navigation: {
                    prevEl: '.a2Box .hm2Prev',
                    nextEl: '.a2Box .hm2Next',
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 4,
                    },
                    767: {
                        slidesPerView: 3,
                    },
                    460: {
                        slidesPerView: 2,
                    },
                }
            })
            new Swiper('.a3Box .swiper-container', {
                speed: 500,
                spaceBetween: '1.5%',
                slidesPerView: 1,
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                watchOverflow: true,
                navigation: {
                    prevEl: '.a3Box .hm2Prev',
                    nextEl: '.a3Box .hm2Next',
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 3,
                    },
                    767: {
                        slidesPerView: 3,
                    },
                    460: {
                        slidesPerView: 2,
                    },
                }
            })
            new Swiper('.a4Box .swiper-container', {
                loop: true,
                speed: 500,
                spaceBetween: '1.5%',
                slidesPerView: 1,
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                watchOverflow: true,
                pagination: {
                    el: '.a4Box .hm-pagination',
                    clickable :true,
                }
            })

            // // 动态内容加载完成后调用 sync 方法，确保在每次动态加载内容后调用 this.$wow.sync() 方法，以便 WOW.js 能够重新扫描页面并为新的 wow 元素添加动画（没起作用）
            // this.$nextTick(() => {
            //   this.$wow.sync();
            // });

        });
        this.getAbout();
        this.getHistory();
        this.getBanner();
        
        this.id = this.$route.query.id;
        setTimeout(() => {
            this.scrollToAnchor(this.$route.query.id)
        }, 100);
    },
    methods: {
        getAbout(){
            home.about().then((res)=>{
                if (res.code === 1) {
                    this.hm2Info = res.data
                } else {
                    this.$toast(res.msg)
                }
            })
        },
        getHistory(){
            home.history().then((res)=>{
                if (res.code === 1) {
                    this.a2List = res.data.rows
                } else {
                    this.$toast(res.msg)
                }
            })
        },
        getBanner(){
            home.banner({site:2}).then((res) => {
                if (res.code === 1) {
                    this.a4List = res.data
                } else {
                    this.$toast(res.msg)
                }
            })
        },
        scrollToAnchor(anchor) {
            const headerHeight = document.querySelector('header').offsetHeight;
            const element = document.getElementById(anchor);
            if (element) {
                window.scrollTo({
                    top: element.offsetTop - headerHeight,
                    // behavior: 'smooth'
                });
            }
        }
    },
    destroyed(){
        
    }
}
</script>

<style lang="scss" scoped>
    @import '@/assets/css/home.scss';
    @import '@/assets/css/about.scss';
</style>